import workspaceQuery from '../../../graphql/queries/customer/CustomerNoteTypeWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/customer/CustomerNoteTypeListQuery.graphql';
import instanceQuery from '../../../graphql/queries/customer/CustomerNoteTypeQuery.graphql';
import defaultQuery from '../../../graphql/queries/customer/CustomerNoteTypeDefault.graphql';
import mutationQuery from '../../../graphql/mutations/customer/CustomerNoteTypeMutation.graphql';
import fragment from '../../../graphql/fragments/customer/CustomerNoteTypeFragment.graphql';
import { Direction } from '../../schema/p4types';

const CustomerNoteType = {
  type: 'CustomerNoteType',
  title: 'Customer Note Types',
  formTitle: 'Customer Note Type',
  formUrl: '/Customers/NoteType/Details/',
  workspaceUrl: '/Customers/NoteType/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
    customVariables: () => {
      return {
        orderBy: 'title',
        orderDirection: Direction.Asc,
      };
    },
  },
  fragment,
  screenReference: 'CUSTOMER_NOTE_TYPES',
};

export default CustomerNoteType;
